import ScrollView from 'devextreme-react/scroll-view';

export function OffboardEmployeePage() {
  return (
    <ScrollView>
      <div style={{ padding: '1rem 1.25rem' }}>
        <h2>Offboard Employee</h2>
        <p>Employee offboarding workflows will live here.</p>
      </div>
    </ScrollView>
  );
}
